import {
  Box,
  ContentRow,
  useComponentsWrapperContext,
  useIsMobileLayout,
} from "@dbn/omnichannel-design-system-g4p";

type Props = {
  children: React.ReactElement<unknown>;
  grow?: boolean;
  mobileRowType?: any;
};

export function ContentWrapper(props: Props) {
  const { componentType } = useComponentsWrapperContext();
  const isMobileLayout = useIsMobileLayout();
  const mobileRowType = props.mobileRowType || "full";
  return (
    <>
      {componentType === "notG4p" && <>{props.children}</>}
      {(!componentType || componentType === "g4p") && (
        <ContentRow
          grow={props.grow}
          type={isMobileLayout ? mobileRowType : "panel-like-margins"}
        >
          <Box grow shrink hAlignContent={"left"}>
            {props.children}
          </Box>
        </ContentRow>
      )}
    </>
  );
}
